// import Http from './http'; // não precisa de .js
import api from "../utils/api";

const config = {
  headers: {
    "Access-Control-Allow-Origin": "*",
    // 'Access-Control-Allow-Origin':'https://super.enercred.com.br',
    "Content-Type": "multipart/form-data",
  },
};

export const uploadInvoice = (formData) => {
  const conta = api.post(
    process.env.VUE_APP_UPLOADINVOICE_URL,
    formData,
    config,
  );

  return conta;
};
